import React from 'react';

import { IOrbitIconProps } from '../../icons/OrbitNewChatIcon';

/**
 * Rail chat-row glyph (Figma 6245:2247): a rounded bubble 10.5 x 7.29, radius 2.04, with a tail at
 * the bottom left, drawn as a 1.02 stroke on the node's own centre lines rather than the filled
 * outlines the file exports. Ink is `currentColor` so the row owns its colour.
 */
const OrbitChatRowIcon: React.FC<IOrbitIconProps> = ({ width = 14, height = 14, className }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    focusable="false"
    aria-hidden="true"
    data-testid="orbit-icon-chat-row"
  >
    <rect
      x="1.75"
      y="2.625"
      width="10.5"
      height="7.2917"
      rx="2.0417"
      stroke="currentColor"
      strokeWidth="1.0208"
      strokeLinejoin="round"
    />
    <path
      d="M4.666 9.9141 L3.791 11.9558 L6.416 9.9141"
      stroke="currentColor"
      strokeWidth="1.0208"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OrbitChatRowIcon;
